
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seller-information",
      function () {
        return require("private-next-pages/seller-information/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seller-information"])
      });
    }
  